<template>
  <Tabs v-if="data.length" class="home-tab-news" animated>
    <Tab v-for="item in data" :key="item.title" :title="item.title">
      <ul class="home-tab-news-list small-list">
        <li v-for="article in item.list" :key="`article-${article.id}`">
          <router-link :to="`/article/${article.id}`">{{article.title}}</router-link>
        </li>
      </ul>
    </Tab>
  </Tabs>
</template>

<script>
import { Tab, Tabs } from 'vant'
import 'vant/es/tabs/style'

export default {
  name: 'mHomeTabNews',
  components: { Tab, Tabs },
  props: {
    data: Array, default: () => []
  }
}
</script>
